// extracted by mini-css-extract-plugin
module.exports = {"t-container":"styles_t-container__0FSUq","text":"styles_text__amEAf"};